import { render, staticRenderFns } from "./MapPopupLocationCard.vue?vue&type=template&id=63bc9783"
import script from "./MapPopupLocationCard.vue?vue&type=script&lang=ts"
export * from "./MapPopupLocationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports